import {faClose} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from 'antd';
import {ReactNode} from 'react';

import {FormattedDateTime} from '../../../provider/locale/formatted-date-time';
import {YandexStoryIllustration} from '../../stories/yandex-story-illustration/yandex-story-illustration';
import {Text} from '../../text/text';

import * as styles from './publication-preview-info.scss';

const DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
};

export type PublicationPreviewRowType = {
    key: string;
    label: ReactNode;
    value: ReactNode;
};

type PropsType = {
    title: string;
    createdAt: string | null;
    thumbnailUrl?: string;
    rows: Array<PublicationPreviewRowType>;
    footer?: ReactNode;
    onClose: VoidFunction;
};

// Right-hand data card of the publication preview: thumbnail + title + date header and a bordered table of data rows.
export function PublicationPreviewInfo(props: PropsType): JSX.Element {
    const {title, createdAt, thumbnailUrl, rows, footer, onClose} = props;

    return (
        <div className={styles.PublicationPreviewInfo}>
            <Button
                className={styles.PublicationPreviewInfo_closeButton}
                icon={<FontAwesomeIcon icon={faClose} />}
                onClick={onClose}
                type="text"
            />

            <div className={styles.PublicationPreviewInfo_header}>
                {thumbnailUrl && <YandexStoryIllustration image={thumbnailUrl} />}

                <div className={styles.PublicationPreviewInfo_headerInfo}>
                    <Text block>{title}</Text>
                    {createdAt && (
                        <Text block secondary>
                            <FormattedDateTime options={DATE_TIME_OPTIONS} value={new Date(createdAt)} />
                        </Text>
                    )}
                </div>
            </div>

            <div className={styles.PublicationPreviewInfo_table}>
                {rows.map((row) => (
                    <div className={styles.PublicationPreviewInfo_tableRow} key={row.key}>
                        <div>
                            <Text block>{row.label}</Text>
                        </div>
                        <div>{row.value}</div>
                    </div>
                ))}
            </div>

            {footer}
        </div>
    );
}
